<template>
  <div class="create-trigger">
    <el-steps class="steps" :active="active" align-center finish-status="success">
      <el-step title="基础信息"></el-step>
      <el-step title="模型配置"></el-step>
    </el-steps>
    <!-- 基础信息 -->
    <div class="form-wrap" v-if="active === 0">
      <el-form ref="formRef" :model="info" :rules="rules">
        <el-form-item label="触发事件名称" prop="triggerName">
          <el-input v-model="info.triggerName" placeholder="请输入触发事件名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="triggerComment">
          <el-input v-model="info.triggerComment" type="textarea" :rows="3" placeholder="请描述清楚该触发事件的功能"></el-input>
        </el-form-item>
        <div class="footer-btns">
          <el-button @click="$router.back()">取消</el-button>
          <el-button type="primary" @click="newStep">下一步</el-button>
        </div>
      </el-form>
    </div>
    <!-- 模型配置 -->
    <div class="model-wrap" v-else-if="active === 1">
      <div class="model-label">触发事件入参</div>
      <div class="model-table">
        <el-button disabled>导入json</el-button>
        <el-button @click="copyClipboard">复制到剪切板</el-button>
        <model-tree :model="requestModel" param="root" disableParam></model-tree>
      </div>
      <div class="model-label"><i>*</i>触发事件出参</div>
      <div class="response-type">
        <el-radio v-model="responseModelType" :label="0">默认 <span class="type-tip">（与上文数据模型一致）</span></el-radio>
        <el-radio v-model="responseModelType" :label="1">自定义</el-radio>
      </div>
      <div class="model-table" v-if="responseModelType === 1">
        <el-button disabled>导入json</el-button>
        <el-button @click="copyClipboard">复制到剪切板</el-button>
        <model-tree :model="responseModel" param="root" disableParam></model-tree>
      </div>
      <div class="footer-btns">
        <el-button @click="active = 0">上一步</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Clipboard } from "@/utils/util";
import ModelTree from "@/views/connector/components/model-tree";
import ConnectorApis from "@/apis/connector";
export default {
  name: "create-trigger",
  props: {},
  data() {
    return {
      id: this.$route.query.id,
      connectorId: this.$route.query.connectorId,
      active: 0,
      info: {
        triggerName: "",
        triggerComment: "",
      },
      rules: {
        triggerName: [{ required: true, message: "请输入触发事件名称" }],
      },
      requestModel: {
        type: "object",
        title: "root",
        description: "当前对象模型根容器",
        properties: {},
      },
      responseModel: {
        type: "object",
        title: "root",
        description: "当前对象模型根容器",
        properties: {},
      },
      responseModelType: 0,
    };
  },
  mounted() {
    if (this.id) this.getTriggerInfo();
  },
  methods: {
    getTriggerInfo() {
      ConnectorApis.getTriggerById(this.id).then((res) => {
        this.info.triggerName = res.triggerName;
        this.info.triggerComment = res.triggerComment;
        if (res.requestModel) this.requestModel = JSON.parse(res.requestModel);
        if (res.responseModel) this.responseModel = JSON.parse(res.responseModel);
        this.responseModelType = res.responseModelType;
      });
    },
    async newStep() {
      await this.$refs.formRef.validate();
      this.active = 1;
    },
    copyClipboard() {
      Clipboard(JSON.stringify(this.requestModel));
    },
    async save() {
      const valiRequest = this.validateModel(this.requestModel.properties);
      const valiResponse = this.validateModel(this.responseModel.properties);
      if (valiRequest || valiResponse) {
        this.$message.warning("必填参数不能为空");
        return;
      }
      const params = {
        connectorId: this.connectorId,
        triggerName: this.info.triggerName,
        triggerComment: this.info.triggerComment,
        requestModel: JSON.stringify(this.requestModel),
        responseModelType: this.responseModelType,
      };
      if (this.responseModel) {
        params.responseModel = JSON.stringify(this.responseModel);
        params.modelMapping = JSON.stringify(this.responseModel);
      }
      if (this.id) {
        params.id = this.id;
        ConnectorApis.editTriggerEvent(params).then((res) => {
          this.$message.success("修改成功");
          setTimeout(() => {
            this.$router.back();
          }, 2000);
        });
      } else {
        ConnectorApis.addTriggerEvent(params).then((res) => {
          this.$message.success("保存成功");
          setTimeout(() => {
            this.$router.back();
          }, 2000);
        });
      }
    },
    validateModel(properties) {
      for (const key in properties) {
        if (!properties[key].title) return true;
        else {
          const children = properties[key].properties;
          if (children) {
            this.validateModel(children);
          }
        }
      }
    },
  },
  components: { ModelTree },
};
</script>
<style scoped lang="scss">
.steps {
  padding-top: 20px;
  min-width: 300px;
  max-width: 1000px;
  margin: auto;
}
.form-wrap {
  padding-top: 60px;
  max-width: 500px;
  margin: auto;
}
.model-wrap {
  padding-top: 20px;
  padding-left: 10px;
  max-width: 1400px;
  margin: auto;
  .model-label {
    padding: 20px 0 10px;
    i {
      font-style: normal;
      margin-right: 4px;
      color: #f56c6c;
    }
  }
  .response-type {
    padding-bottom: 10px;
  }
  .type-tip{
    color: #aaa;
  }
  .model-table {
    padding-top: 10px;
  }
}
.footer-btns {
  padding-top: 50px;
  margin: auto;
  text-align: center;
}
</style>
